import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card_2.css";
import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";
import { Context } from "../../../utils/context";
import { addWishlist } from "../../../utils/apis/Wishlist/Wishlist";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";
import { encodeId } from "../../../utils/common";

const Product_Info_Card_2 = ({
  prodname,
  image,
  selling_price,
  mrp,
  discount,
  showQty,
  product,
  product_id,
  variant_id,
}) => {
  const [favouriteProduct, setFavouriteProduct] = useState();
  

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);

  const {
    shimmerLoader,
    setShimmerLoader,
    addCartModal,
    setAddCartModal,
    wishlistData,
    wishlistContext,
    triggerCartUpdate,
    signin,
  } = useContext(Context);

  const handleHeartClick = async (data) => {
    // setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        wishlistContext();
      }
      setShimmerLoader(false);
    } else {
      setShimmerLoader(false);
      setModalLShow(true);
      // setCount((count) => count + 1);
      // navigate("/login");
    }
  };

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  return (
    <section className="Product_Info_Card_2_Section">
      <div className="Product_Info_Card_2">
        <div
          className="upper_image_section"
          onClick={() => navigate(`/vendor-page/${encodeId(product_id)}`)}
        >
          <div className="card_img_holder">
            <img className="" src={image} alt={prodname} />
          </div>

          {discount && (
            <div className="text_div">
              <div className="discont_div">
                <p className="discount_text">{discount}% Off</p>
              </div>
            </div>
          )}
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => navigate(`/vendor-page/${encodeId(product_id)}`)}
          >
            {prodname}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">₹{selling_price}</p>
              <p className="mrp">₹{mrp}</p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

            {showQty && (
              <div className="kilo_main_div"    onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                        navigate(`/vendor-page/${encodeId(product_id)}`);
                      }}>
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">
                      {product?.product_variants?.[0]?.v_name}
                    </p>
                  </div>
                  {/* <div>
                    <p className="icon_p">
                     
                    </p>
                  </div> */}
                </div>
              </div>
            )}
          </div>

          <div className="text-center btn_holder">
            {!product?.outOfStock ? (
              <>
                {!showIncrement ? (
                  <div className="">
                    <Blue_Btn
                      btn_name="Add to Cart"
                      leftIcon={faBasketShopping}
                      onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                        navigate(`/vendor-page/${encodeId(product_id)}`);
                      }}
                    />
                  </div>
                ) : (
                  <div className="">{/* <IncrementDecrementBtn /> */}</div>
                )}
              </>
            ) : (
              <div className="">
                <Red_Outline_Btn btn_name="Out of Stock" />
              </div>
            )}
          </div>

          <div
            className="favourite_div"
            onClick={(e) => {
              e.stopPropagation();
              handleHeartClick({
                product_id: product_id,
                variant_id: variant_id,
              });
            }}
          >
            <FontAwesomeIcon
              icon={faHeart}
              className={
                wishlistData?.some(
                  (item) =>
                    item.product_id === product_id &&
                    item.variant_id === variant_id
                )
                  ? "heart_icon active"
                  : "heart_icon "
              }
              //   className={`heart_icon ${
              //     prodname == favouriteProduct ? "active" : ""
              //   }`}
            />
          </div>
        </div>
      </div>

      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />
    </section>
  );
};

export default Product_Info_Card_2;
